/* Collection filters: make / brand tags, active filter chips,
   "my car" bar and the mobile filter drawer. */
(function () {
  'use strict';
  var coll = document.querySelector('[data-be-coll]');
  if (!coll) { return; }
  var base = coll.getAttribute('data-base') || '/collections/all';
  var side = coll.querySelector('[data-be-side]');
  var overlay = coll.querySelector('[data-be-overlay]');

  /* ---------- Current state from the URL ---------- */
  var rest = window.location.pathname.indexOf(base) === 0 ? window.location.pathname.slice(base.length) : '';
  rest = rest.replace(/^\/+|\/+$/g, '');
  var cur = rest ? decodeURIComponent(rest).split('+').filter(Boolean).map(function (t) { return t.toLowerCase(); }) : [];
  var params = new URLSearchParams(window.location.search);
  params.delete('page');
  var priceKeys = [];
  params.forEach(function (v, k) { if (k.indexOf('filter.v.price') === 0) { priceKeys.push(k); } });

  var qs = function (p) { var s = p.toString(); return s ? '?' + s : ''; };
  var urlFor = function (tags, p) {
    return base + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '') + qs(p || params);
  };
  var without = function (list, drop) { return list.filter(function (t) { return drop.indexOf(t) === -1; }); };

  /* ---------- Saved vehicle ---------- */
  var car = null;
  try { car = JSON.parse(localStorage.getItem('be-vehicle') || 'null'); } catch (e) { car = null; }
  var fitTag = car && car.tokens && car.tokens.length === 1 ? String(car.tokens[0]).toLowerCase() : '';

  /* ---------- Filter links (make, brand) ---------- */
  var labels = {};
  var groups = {};
  coll.querySelectorAll('[data-f-tag]').forEach(function (a) {
    var g = a.getAttribute('data-f-group'), t = a.getAttribute('data-f-tag');
    labels[t] = a.getAttribute('data-f-label') || a.textContent.trim();
    (groups[g] = groups[g] || []).push(t);
  });
  if (fitTag) { labels[fitTag] = 'Fits your ' + car.label; groups.fit = [fitTag]; }
  coll.querySelectorAll('[data-f-tag]').forEach(function (a) {
    var g = a.getAttribute('data-f-group'), t = a.getAttribute('data-f-tag');
    var on = cur.indexOf(t) !== -1;
    a.classList.toggle('is-on', on);
    if (a.hasAttribute('role')) { a.setAttribute('aria-checked', on ? 'true' : 'false'); }
    a.href = on ? urlFor(without(cur, [t])) : urlFor(without(cur, groups[g]).concat(t));
  });

  /* Category links keep the chosen filters. */
  if (cur.length || priceKeys.length) {
    coll.querySelectorAll('[data-f-cat]').forEach(function (a) {
      var u = new URL(a.href, window.location.origin);
      if (u.pathname.indexOf('/collections/') !== 0) { return; }
      a.href = u.pathname.replace(/\/+$/, '') + (cur.length ? '/' + cur.map(encodeURIComponent).join('+') : '') + qs(params);
    });
  }

  /* ---------- Active filter chips ---------- */
  var active = coll.querySelector('[data-be-active]');
  var count = 0;
  var chip = function (text, href) {
    var a = document.createElement('a');
    a.className = 'be-achip';
    a.href = href;
    a.rel = 'nofollow';
    a.setAttribute('aria-label', 'Remove filter: ' + text);
    a.appendChild(document.createTextNode(text));
    var x = document.createElement('span');
    x.setAttribute('aria-hidden', 'true');
    x.textContent = '×';
    a.appendChild(x);
    active.appendChild(a);
    count++;
  };
  var money = function (v) { return '$' + Number(v).toLocaleString('en-AU'); };
  if (priceKeys.length) {
    var lo = params.get('filter.v.price.gte'), hi = params.get('filter.v.price.lte');
    var txt = lo && hi ? money(lo) + ' – ' + money(hi) : lo ? 'From ' + money(lo) : 'Up to ' + money(hi);
    var p2 = new URLSearchParams(params.toString());
    priceKeys.forEach(function (k) { p2.delete(k); });
    chip(txt, urlFor(cur, p2));
  }
  cur.forEach(function (t) { chip(labels[t] || t.replace(/-/g, ' '), urlFor(without(cur, [t]))); });
  var clearAll = new URLSearchParams(params.toString());
  priceKeys.forEach(function (k) { clearAll.delete(k); });
  var clearHref = base + qs(clearAll);
  if (count > 1) {
    var c = document.createElement('a');
    c.className = 'be-aclear';
    c.href = clearHref;
    c.textContent = 'Clear all';
    active.appendChild(c);
  }
  if (count) { active.hidden = false; }
  coll.querySelectorAll('[data-be-clearall]').forEach(function (a) { a.href = clearHref; });
  var badge = coll.querySelector('[data-be-fcount]');
  if (badge && count) { badge.textContent = count; badge.hidden = false; }

  /* ---------- My car bar ---------- */
  var fit = coll.querySelector('[data-be-fit]');
  if (fit) {
    var span = function (cls, text) { var s = document.createElement('span'); if (cls) { s.className = cls; } if (text) { s.textContent = text; } return s; };
    var txtBox = span('be-fit__txt');
    var acts = span('be-fit__acts');
    if (car && car.label) {
      var small = document.createElement('small');
      small.textContent = 'Your car';
      var b = document.createElement('b');
      b.textContent = car.label;
      txtBox.appendChild(small);
      txtBox.appendChild(b);
      var main = document.createElement('a');
      main.className = 'be-fit__btn';
      if (fitTag) {
        var fitOn = cur.indexOf(fitTag) !== -1;
        main.textContent = fitOn ? 'Show all parts' : 'Only show parts that fit';
        if (fitOn) { main.classList.add('is-on'); }
        main.href = fitOn ? urlFor(without(cur, [fitTag])) : urlFor(cur.concat(fitTag));
        main.rel = 'nofollow';
      } else {
        main.textContent = 'Shop parts for it';
        main.href = car.url || '/search';
      }
      acts.appendChild(main);
      var change = document.createElement('a');
      change.className = 'be-fit__lnk';
      change.href = '#be-finder';
      change.textContent = 'Change car';
      change.addEventListener('click', function (e) {
        var f = document.getElementById('be-finder');
        if (f) { e.preventDefault(); f.classList.add('is-open'); f.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
      acts.appendChild(change);
      var forget = document.createElement('button');
      forget.type = 'button';
      forget.className = 'be-fit__lnk';
      forget.textContent = 'Forget';
      forget.addEventListener('click', function () {
        try { localStorage.removeItem('be-vehicle'); } catch (e) {}
        if (fitTag && cur.indexOf(fitTag) !== -1) { window.location.href = urlFor(without(cur, [fitTag])); }
        else { window.location.reload(); }
      });
      acts.appendChild(forget);
    } else {
      txtBox.appendChild(span('', 'Pick your car and we\'ll tick every part that fits it.'));
      var pick = document.createElement('a');
      pick.className = 'be-fit__btn';
      pick.href = '#be-finder';
      pick.textContent = 'Choose your car';
      pick.addEventListener('click', function (e) {
        var f = document.getElementById('be-finder');
        if (f) { e.preventDefault(); f.classList.add('is-open'); f.scrollIntoView({ behavior: 'smooth', block: 'start' }); var s = f.querySelector('select'); if (s) { s.focus(); } }
      });
      acts.appendChild(pick);
    }
    fit.appendChild(txtBox);
    fit.appendChild(acts);
    fit.hidden = false;
  }

  /* ---------- Mobile filter drawer ---------- */
  var toggle = coll.querySelector('[data-be-ftoggle]');
  var lastFocus = null;
  var openDrawer = function () {
    lastFocus = document.activeElement;
    side.classList.add('is-open');
    overlay.hidden = false;
    document.documentElement.classList.add('be-noscroll');
    if (toggle) { toggle.setAttribute('aria-expanded', 'true'); }
    var first = side.querySelector('[data-be-fclose]');
    if (first) { first.focus(); }
  };
  var closeDrawer = function () {
    side.classList.remove('is-open');
    overlay.hidden = true;
    document.documentElement.classList.remove('be-noscroll');
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); }
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  };
  if (toggle) { toggle.addEventListener('click', openDrawer); }
  coll.querySelectorAll('[data-be-fclose]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) { overlay.addEventListener('click', closeDrawer); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && side.classList.contains('is-open')) { closeDrawer(); } });
})();
